import React from 'react';
import ImageGalleryViewer from '../Components/ImageGalleryViewer';
// import { setCurrentIndex, show, previous, next } from '../Actions/LightboxImages.action';

const ImageGalleryContainer = props => <ImageGalleryViewer {...props} />;

// const mapStateToProps = (state) => {
//     return {
//         isOpen: state.lightboxImages.visible,
//         currentImage: state.lightboxImages.index,
//     }
// }

// const mapDispatchToProps = dispatch => {
//     return {
//         onClose: () => { 
//             dispatch(show(false))
//             document.body.style.overflow = "visible"; 
//      },
//         onClickNext: () => {dispatch(next())},
//         onClickPrev: () => dispatch(previous()),
//         onClickThumbnail: (index) => {
//             dispatch(show(true));
//             dispatch(setCurrentIndex(index));
            
//         },
        
//     }
// }

export default ImageGalleryContainer;